import { Box, SxProps, TextField, Theme, Typography } from "@mui/material";
import palette from "@styles/palette";
import typography from "@styles/typography";
import React, { useRef } from "react";

export const ChatTextField = ({
  label,
  defaultValue,
  register,
  placeholder,
  disabled,
  EndAdornment,
  sx,
}: {
  label: string;
  defaultValue: string | number | null | undefined;
  register: any;
  placeholder: string;
  disabled?: boolean;
  EndAdornment?: JSX.Element;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Box
      sx={{
        padding: 10,
        border: "1px solid",
        borderColor: palette.brand.neutral.darkGray,
        borderRadius: 6,
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        ...sx,
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "100%" }}
      >
        <Typography
          variant="appCaption"
          color={palette.brand.neutral.darkGray}
        >
          {label}
        </Typography>
        <TextField
          {...register}
          placeholder={placeholder}
          fullWidth
          disabled={disabled}
          className="empty"
          defaultValue={defaultValue}
          InputLabelProps={{
            style: { color: palette.brand.neutral.darkGray },
          }}
        />
      </Box>
      {EndAdornment}
    </Box>
  );
};
